import { render, staticRenderFns } from "./cutting-bed.vue?vue&type=template&id=39fd95ec&"
import script from "./cutting-bed.vue?vue&type=script&lang=js&"
export * from "./cutting-bed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fd95ec')) {
      api.createRecord('39fd95ec', component.options)
    } else {
      api.reload('39fd95ec', component.options)
    }
    module.hot.accept("./cutting-bed.vue?vue&type=template&id=39fd95ec&", function () {
      api.rerender('39fd95ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mes/components/productionProgress/cutting-bed.vue"
export default component.exports